import Help from "@mui/icons-material/Help";
import { Avatar, Grid, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import MUITooltip from "@mui/material/Tooltip";

const StyledPaper = styled(Paper)(() => ({
    padding: "4px 0",
    marginBottom: "12px",
}));

const StyledAvatar = styled(Avatar)(() => ({
    background: "#2C99D2",
    margin: 16,
}));

const StyledDefTerm = styled("span")(() => ({
    fontSize: "13px",
    textTransform: "uppercase",
    color: "#9E9E9E",
    fontWeight: 600,
    display: "inline-block",
    padding: "0 0 8px",
}));

const StyledDefData = styled("span")(() => ({
    fontSize: 22,
    fontWeight: 700,
}));

const KMStatBox = (props) => {
    const { icon, tooltip, number, title } = props;
    return (
        <StyledPaper>
            <Grid container sx={{ alignItems: "center" }}>
                <Grid>
                    <StyledAvatar>{icon}</StyledAvatar>
                </Grid>
                <Grid>
                    <StyledDefTerm>
                        {title}
                        {tooltip && (
                            <MUITooltip title={tooltip} placement="top-end">
                                <Help style={{ fontSize: "110%", marginLeft: "4px", color: "grey" }} />
                            </MUITooltip>
                        )}
                    </StyledDefTerm>
                    <br />
                    <StyledDefData>{number}</StyledDefData>
                </Grid>
            </Grid>
        </StyledPaper>
    );
};

export default KMStatBox;
